import type { ReactNode } from "react";

export { slugify } from "@/lib/blog-meta";


function renderInline(text: string): ReactNode {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, i) =>
    part.startsWith("**") && part.endsWith("**") ? (
      <strong key={i} className="font-semibold text-foreground">
        {part.slice(2, -2)}
      </strong>
    ) : (
      part
    ),
  );
}

/**
 * Renders the blog body format: blank-line-separated blocks, "## "/"### "
 * headings, "- " list items and **bold** inline. Anything else is a paragraph.
 */
export function BlogContent({ content }: { content: string }) {
  const blocks = content.split(/\n{2,}/).filter((b) => b.trim().length > 0);

  return (
    <div className="space-y-6 text-base leading-[1.85] text-muted-foreground sm:text-lg">
      {blocks.map((block, i) => {
        const trimmed = block.trim();
        if (trimmed.startsWith("### ")) {
          return (
            <h3 key={i} className="pt-4 text-xl font-semibold text-foreground">
              {renderInline(trimmed.slice(4))}
            </h3>
          );
        }
        if (trimmed.startsWith("## ")) {
          return (
            <h2 key={i} className="pt-6 text-2xl font-semibold text-foreground sm:text-3xl">
              {renderInline(trimmed.slice(3))}
            </h2>
          );
        }
        if (trimmed.startsWith("- ")) {
          return (
            <ul key={i} className="list-disc space-y-2 pl-6">
              {trimmed.split("\n").map((item, j) => (
                <li key={j}>{renderInline(item.replace(/^-\s+/, ""))}</li>
              ))}
            </ul>
          );
        }
        return <p key={i}>{renderInline(trimmed)}</p>;
      })}
    </div>
  );
}

